import { api, generateCRUDInterface } from "aldoo-ra/API"

// Create API client for crud service
const crudAPI = api("crud")

// Generate CRUD interface for CSForwardRule model
const ForwardRuleCRUD = generateCRUDInterface(crudAPI, "CSForwardRule")

/**
 * Get all forward rules
 * @param {Object} options - Query options
 * @returns {Promise<Object>} - API response with rules
 */
export const GetForwardRules = async (options = {}) => {
  // If the caller explicitly wants deleted items, use direct CRUD API
  // because generateCRUDInterface always filters out deleted items
  if (options.match?.deleted === true) {
    return await crudAPI({
      get: {
        model: "CSForwardRule",
        match: options.match,
        page: options.page,
        itemsPerPage: options.itemsPerPage,
        sort: options.sort,
        search: options.search,
      }
    })
  }

  // For non-deleted items, use the CRUD interface (it auto-filters deleted)
  return await ForwardRuleCRUD.Get(options)
}

/**
 * Create a new forward rule
 * @param {Object} rule - Rule data { subscriber, tags }
 * @returns {Promise<Object>} - API response
 */
export const CreateForwardRule = async (rule) => {
  return await ForwardRuleCRUD.Create(rule)
}

/**
 * Update an existing forward rule
 * @param {Object} rule - Rule data with _id
 * @returns {Promise<Object>} - API response
 */
export const UpdateForwardRule = async (rule) => {
  return await ForwardRuleCRUD.Update(rule)
}

/**
 * Delete a forward rule (soft delete)
 * @param {String} id - Rule ID
 * @returns {Promise<Object>} - API response
 */
export const DeleteForwardRule = async (id) => {
  return await ForwardRuleCRUD.SoftDelete({ _id: id })
}

/**
 * Save a forward rule (create or update)
 * @param {Object} rule - Rule data
 * @returns {Promise<Object>} - API response
 */
export const SaveForwardRule = async (rule) => {
  return await ForwardRuleCRUD.Save(rule)
}
